<template lang="html">
    <!-- Use the AppTitle component -->
    <AppTitle>
        <template #title>ถังดับเพลิง</template>
        <template #subtitle>Wanon Niwat Hospital [WEBPORTAL WNH]</template>
        <template #breadcrumb>Dashboard</template>
    </AppTitle>

    <div class="row">
        <div class="col-md-12">
            <div class="tile">
                <Overlay :showOverlay="!items.length" />
                <!-- <div class="tile-title-w-btn">
                    <h3 class="title">ถังดับเพลิง ทั้งหมด</h3>
                    <p>
                        <a class="btn btn-primary icon-btn" href="#" @click="openAddModal">
                            <i class="bi bi-plus-square me-2"></i> Add Item
                        </a>
                    </p>
                </div> -->

                <div class="tile-title-w-btn d-flex justify-content-between align-items-center">
                    <h3 class="title">ถังดับเพลิง ทั้งหมด</h3>

                    <div class="d-flex align-items-center gap-2">
                        <select v-model="filterKey" class="form-select" style="width: auto;">
                            <option value="code">Code</option>
                            <option value="name">Name</option>
                            <option value="details">Details</option>
                            <option value="location">Location</option>
                            <option value="group.name">Department</option>
                        </select>

                        <!-- Show input if filterKey is not 'group.name' -->
                        <input v-if="filterKey !== 'group.name'" type="text" v-model="filterText"
                            placeholder="Search..." class="form-control" style="width: 200px;" />

                        <!-- Show department dropdown if filterKey is 'group.name' -->
                        <select v-else class="form-select" v-model="selectedGroupId" style="width: 200px;">
                            <option value="">All Departments</option>
                            <option v-for="(item, index) in groups" :key="index" :value="item.id">
                                {{ item.name }}
                            </option>
                        </select>

                        <p>
                            <a class="btn btn-primary icon-btn" href="#" @click="openAddModal">
                                <i class="bi bi-plus-square me-2"></i> Add Item
                            </a>
                        </p>
                    </div>
                </div>

                <div class="tile-body">
                    <div class="table-responsive">
                        <table class="table table-bordered table-hover">
                            <thead>
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">Code</th>
                                    <th scope="col">Name</th>
                                    <th scope="col">Details</th>
                                    <th scope="col">Location</th>
                                    <th scope="col">Department</th>
                                    <th scope="col">Installed At</th>
                                    <th scope="col">Warranty Expires At</th>
                                    <th scope="col">Manage</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in filteredItems" :key="item.id">
                                    <th scope="row">{{ index + 1 }}</th>
                                    <td>{{ item.code }}</td>
                                    <td>{{ item.name }}</td>
                                    <td>{{ item.details }}</td>
                                    <td>{{ item.location }}</td>
                                    <td>{{ item.group?.name }}</td>
                                    <td>{{ formatDate(item.installed_at) }}</td>
                                    <td>{{ formatDate(item.warranty_expires_at) }}</td>
                                    <td>
                                        <div class="btn-group btn-group-sm" role="group"
                                            aria-label="Basic mixed styles example">
                                            <button type="button" class="btn btn-warning" @click="openEditModal(item)">
                                                <i class="bi bi-pencil"></i> Edit
                                            </button>
                                            <button type="button" class="btn btn-danger" @click="handleDelete(item.id)">
                                                <i class="bi bi-trash"></i> Delete
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- Modal stays unchanged -->
                    <div class="modal fade" id="myModal" tabindex="-1" aria-labelledby="modalLabel" aria-hidden="true">
                        <div class="modal-dialog modal-dialog-centered">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title" id="modalLabel">
                                        {{ modalMode === 'edit' ? 'Edit Item' : 'Add Item' }}
                                    </h5>
                                    <button type="button" class="btn-close" aria-label="Close"
                                        @click="hideModal"></button>
                                </div>
                                <form @submit.prevent="handleSubmit(editingItem)">
                                    <div class="modal-body">
                                        <!-- Download QR code button -->
                                        <div v-if="modalMode != 'add'" class="text-center">
                                            <button type="button" @click="downloadQRCode"
                                                class="btn btn-success">Download
                                                QR
                                                Code</button>
                                        </div>

                                        <!-- QRCode generation -->
                                        <div v-if="editingItem.code" ref="qrCodeContainer" class="text-center p-4">
                                            <div class="text-center mb-3">
                                                <qrcode-vue :value="`${url}/${editingItem.code}`"
                                                    size="128"></qrcode-vue>
                                            </div>
                                            <p class="mb-0">
                                                {{ editingItem.name }} [{{ editingItem.code }}]
                                                {{ editingItem.location }}
                                            </p>

                                            <p class="mb-0">
                                                {{ editingItem.group?.name }}
                                            </p>
                                            <!-- <p v-clipboard:copy="`${url}/${editingItem.code}`" class="text-center">
                                                {{ url }}/{{ editingItem.code }}
                                            </p> -->
                                        </div>

                                        <!-- Name Field -->
                                        <div class="mb-3">
                                            <label for="name" class="form-label">Name</label>
                                            <input type="text" id="name" class="form-control" v-model="editingItem.name"
                                                required />
                                        </div>

                                        <!-- Details Field -->
                                        <div class="mb-3">
                                            <label for="details" class="form-label">Details</label>
                                            <textarea id="details" class="form-control"
                                                v-model="editingItem.details"></textarea>
                                        </div>

                                        <div class="mb-3">
                                            <label for="name" class="form-label">Location</label>
                                            <input type="text" id="name" class="form-control"
                                                v-model="editingItem.location" />
                                        </div>

                                        <div class="mb-3">
                                            <label for="group" class="form-label">Department</label>
                                            <select id="group" class="form-select" v-model="editingItem.group_id"
                                                required>
                                                <option value="" disabled>- Select -</option>
                                                <option v-for="dept in groups" :key="dept.id" :value="dept.id">
                                                    {{ dept.name }}
                                                </option>
                                            </select>
                                        </div>

                                        <!-- Installed At Field -->
                                        <div class="mb-3">
                                            <label for="installed_at" class="form-label">Installed At</label>
                                            <input type="date" id="installed_at" class="form-control"
                                                v-model="editingItem.installed_at" required />
                                        </div>

                                        <!-- Warranty Expires At Field -->
                                        <div class="mb-3">
                                            <label for="warranty_expires_at" class="form-label">Warranty Expires
                                                At</label>
                                            <input type="date" id="warranty_expires_at" class="form-control"
                                                v-model="editingItem.warranty_expires_at" required />
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary"
                                            @click="hideModal">Close</button>
                                        <button type="submit" class="btn btn-primary" :disabled="isSubmitting">
                                            <span v-if="isSubmitting">
                                                <span class="spinner-border spinner-border-sm me-1" role="status"
                                                    aria-hidden="true"></span>
                                                Saving...
                                            </span>
                                            <span v-else>Save changes</span>
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { Modal } from 'bootstrap';
import { ref, reactive, nextTick, onMounted } from 'vue';
import axiosInstance from '@/utils/axiosInstance';
import { showErrorAlert, showCreateAlert, showUpdateAlert, showDeleteAlert, showConfirm } from '@/utils/sweetalert2-utils';
import Overlay from '@/components/Overlay.vue';
import { formatDate } from '@/utils/dateUtils';
import QrcodeVue from 'qrcode.vue';
import html2canvas from 'html2canvas';
import AppTitle from '@/layouts/AppTitle.vue';

// Refs
const qrCodeContainer = ref(null);
const url = ref(`${process.env.VUE_APP_URL_BASE}/view-fire-extinguisher`);
const items = ref([]);
const groups = ref([]);
const modalMode = ref('add');
const editingItem = reactive({
    code: '',
    name: '',
    details: '',
    location: '',
    group_id: '',
    installed_at: '',
    warranty_expires_at: ''
});

const filterKey = ref('code');
const filterText = ref('');

import { computed } from 'vue';
const selectedGroupId = ref('');

const filteredItems = computed(() => {
    // if (!filterText.value.trim()) return items.value;

    // return items.value.filter(item => {
    //     const value = filterKey.value === 'group.name'
    //         ? item.group?.name || ''
    //         : item[filterKey.value] || '';

    //     return value.toLowerCase().includes(filterText.value.toLowerCase());
    // });

    return items.value.filter(item => {
        if (filterKey.value === 'group.name') {
            return selectedGroupId.value
                ? item.group_id === selectedGroupId.value
                : true;
        } else {
            const value = item[filterKey.value] || '';
            return value.toLowerCase().includes(filterText.value.toLowerCase());
        }
    });

});

// Functions
const fetchData = async () => {
    try {
        const [Items, departmentsRes] = await Promise.all([
            axiosInstance.get('/fire_extinguisher'),
            axiosInstance.get('/group'),
        ]);
        items.value = Items.data;
        groups.value = departmentsRes.data;
    } catch (error) {
        showErrorAlert('ไม่สามารถโหลดข้อมูลได้');
    }
};

const handleDelete = async (id) => {
    const result = await showConfirm();
    if (result.isConfirmed) {
        try {
            await axiosInstance.delete(`/fire_extinguisher/${id}`);
            items.value = items.value.filter(item => item.id !== id);
            showDeleteAlert();
        } catch (error) {
            showErrorAlert('เกิดข้อผิดพลาดในการลบรายการ');
        }
    }
};

const isSubmitting = ref(false);

const handleSubmit = async (updatedItem) => {
    isSubmitting.value = true;

    try {
        if (modalMode.value === 'edit') {
            await axiosInstance.put(`/fire_extinguisher/${updatedItem.id}`, updatedItem);
            showUpdateAlert();
        } else {
            await axiosInstance.post('/fire_extinguisher', updatedItem);
            showCreateAlert();
        }
        fetchData();
        hideModal();
    } catch (error) {
        showErrorAlert('เกิดข้อผิดพลาดในการบันทึกรายการ');
    } finally {
        isSubmitting.value = false;
    }
};

const showModal = () => {
    nextTick(() => {
        const modalElement = document.getElementById('myModal');
        if (modalElement) {
            const modal = new Modal(modalElement);
            modal.show();
        }
    });
};

const hideModal = () => {
    const modalElement = document.getElementById('myModal');
    const modal = Modal.getInstance(modalElement);
    if (modal) modal.hide();
};

const openAddModal = () => {
    Object.assign(editingItem, { name: 'ถังดับเพลิง', details: '', location: '' });
    modalMode.value = 'add';
    showModal();
};

const openEditModal = (item) => {
    Object.assign(editingItem, item);
    modalMode.value = 'edit';
    showModal();
};

const downloadQRCode = () => {
    const qrCodeElement = qrCodeContainer.value;
    if (qrCodeElement) {
        html2canvas(qrCodeElement).then((canvas) => {
            const imageUrl = canvas.toDataURL('image/png');
            const link = document.createElement('a');
            link.href = imageUrl;
            link.download = `${editingItem.code}_qr_code.png`;
            link.click();
        });
    }
};

onMounted(fetchData);
</script>
